// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"575":"fed9df55","864":"5a509671","915":"cb8a91c5"}[chunkId] + ".chunk.css";
};